export type ApprovalMode = 'require_approval' | 'run_all';

export const APPROVAL_MODE_DEFAULT: ApprovalMode = 'require_approval';

const APPROVAL_STORAGE_KEY = 'aibuild_approval_mode';
const APPROVAL_DEFAULT_KEY = 'aibuild_approval_mode_default';

const VALID_MODES: ReadonlySet<string> = new Set<ApprovalMode>(['require_approval', 'run_all']);

const isValidApprovalMode = (value: unknown): value is ApprovalMode =>
  typeof value === 'string' && VALID_MODES.has(value);

export const getStoredApprovalMode = (conversationId: string | null): ApprovalMode | null => {
  if (conversationId) {
    try {
      const stored = localStorage.getItem(APPROVAL_STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        const value = parsed[conversationId];
        if (isValidApprovalMode(value)) return value;
      }
    } catch {
      // Fall through to global default
    }
  }
  // Fall back to the global default (set by TaskPrompt or last per-conversation selection)
  try {
    const value = localStorage.getItem(APPROVAL_DEFAULT_KEY);
    return isValidApprovalMode(value) ? value : null;
  } catch {
    return null;
  }
};

export const setStoredApprovalMode = (conversationId: string | null, mode: ApprovalMode): void => {
  // Always update the global default so new conversations inherit the last choice
  try {
    localStorage.setItem(APPROVAL_DEFAULT_KEY, mode);
  } catch {
    // Ignore storage errors
  }
  if (!conversationId) return;
  try {
    const stored = localStorage.getItem(APPROVAL_STORAGE_KEY);
    const parsed = stored ? JSON.parse(stored) : {};
    parsed[conversationId] = mode;
    localStorage.setItem(APPROVAL_STORAGE_KEY, JSON.stringify(parsed));
  } catch {
    // Ignore storage errors
  }
};
